import { Actions } from '@components/shared/Actions'
import { EyeIcon } from '@assets/svgs/EyeIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { ClByUserCodeItemProps } from '@pages/Users/context/types'

interface ParseProfitCenterGridProps {
  data: ClByUserCodeItemProps[]
  onSeeMore: (data: ClByUserCodeItemProps) => void
}

export const parseProfitCenterGrid = ({ data, onSeeMore }: ParseProfitCenterGridProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'id',
      columnName: 'ID',
      value: item.id || '-',
      align: 'center',
      sortable: true,
      minWidth: '4rem'
    },
    {
      id: 'code',
      columnName: 'Código',
      align: 'center',
      value: item.code || '-',
      sortable: true,
      minWidth: '8rem'
    },
    {
      id: 'profitCenterDescription',
      columnName: 'Centro de Lucro',
      align: 'center',
      value: item.profitCenterDescription || '-',
      sortable: true,
      minWidth: '18rem'
    },
    {
      id: 'buDescription',
      columnName: 'BU',
      align: 'center',
      value: item.buDescription || '-',
      sortable: true,
      minWidth: '11rem'
    },
    {
      id: 'segmentDescription',
      columnName: 'Portfólio',
      align: 'center',
      value: item.segmentDescription || '-',
      sortable: true,
      minWidth: '14rem'
    },
    {
      id: 'boardOfDirectorsDescription',
      columnName: 'Diretoria',
      align: 'center',
      value: item.boardOfDirectorsDescription,
      sortable: true,
      minWidth: '14rem'
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: <Actions actions={[{
        label: 'Ver mais',
        icon: <EyeIcon />,
        onClick: () => onSeeMore(item)
      }]} />
    }
  ])

  return parsedData
}
